import styles from "./styles.module.scss";

export const BorderArticle = ({children, style}) => {
  return (
    <article
      className={styles.article}
      style={style}
    >
      {children}
    </article>
  );
};

// чтобы правильно работали стили компонента - нужно его родителю задать "z-index: 1;"
